import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { dataToXLS, getFormattedTime } from '../../../../core/utils'
import { SIR_TABLE_COLUMNS, ADDITIONAL_EXPORT } from '../table'
import { useSirContext } from '../../contexts'
import { useSirCalls } from '../../hooks'
import { ExportSomethingDialog } from './export-something.dialog'

export const ExportToXLSBtn = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getSirApps } = useSirCalls()
  const {
    actions: { open },
  } = useModalContext()
  const { tableSelection, search } = useSirContext()
  const from = 'sir'

  const [loading, setLoading] = useState(false)

  const mainExport = async (data) => {
    const fileName = `solicitudes_${getFormattedTime()}.xlsx`
    const columns = [...SIR_TABLE_COLUMNS, ...ADDITIONAL_EXPORT]
    await dataToXLS(data, columns, combos, intl, from, fileName)
  }

  const handleExportAll = async () => {
    setLoading(true)
    try {
      const { data } = await getSirApps({
        params: { ...search, _num_x_pagina: 10000, _pagina: 1 },
      })
      await mainExport(data.solicitudes)
    } catch (error) {
      console.error('Error al exportar todos los datos:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    if (!tableSelection?.length) {
      open({
        Component: ExportSomethingDialog,
      })
      return
    }

    setLoading(true)
    try {
      await mainExport(tableSelection)
    } catch (error) {
      console.error('Error al exportar la selección:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        labelM="sm"
        onClick={handleExport}
        style={{ marginRight: '1em' }}
        loading={loading}
        disabled={loading}
      >
        {intl.formatMessage(
          { id: 'pages.sir.exportToXLS.exportSelectionBtn.title' },
          { count: tableSelection.length }
        )}
      </ThemeButton>
      <ThemeButton
        color="primary"
        labelM="sm"
        loading={loading}
        disabled={loading}
        style={{ marginRight: '1em' }}
        onClick={handleExportAll}
      >
        {intl.formatMessage({ id: 'pages.sir.exportToXLS.exportAllBtn.title' })}
      </ThemeButton>
    </>
  )
}
